/**
 * Agent trigger action key constants
 * These values come from the agent workflow trigger.action_key field
 */

/** On-demand agents triggered by direct messages to the agent */
export const ON_DEMAND_WORKFLOW_ACTION_KEY = "zapier_bot_dm_trigger";

/** Agents triggered when a Zap runs */
export const TRIGGER_VIA_ZAP_ACTION_KEY = "zapier_zap_trigger";
